import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const AssistantIcon: FC<IconProps> = ({ width = 36, height = 42, ...rest }) => (
  <Icon type="Assistant" width={width} height={height} alt="Companion assisting a Person of Determination" {...rest} />
)
